/**
 * The line under the Next week's intake figure (#5456): what that figure is, by how the person
 * chose it on the check-up's food step. Kept free of Angular so a unit test can reach it
 * (`next-intake-source.test.ts`).
 *
 * The figure is last week's logged average only when the person picked "logged average". For
 * "calorie target" it is their target and for "typed in" the number they typed, so the line never
 * calls those an average. Example: a client who reported their 1552 kcal target while the week
 * logged 1643 reads "Their calorie target, reported as last week's intake".
 */

import { CalorieIntakeBaseline } from '@cf-shared/data-model/log-weekly-checkup';
import type { TranslationFunctions } from '../../../gensrc/i18n/i18n-types';
import type { TranslatedString } from 'models/translated-string';

/** the line for the given choice; a coach reads "Their calorie target", the person "Your calorie target" */
export function reportedIntakeSourceText(source: CalorieIntakeBaseline | undefined, forCoach: boolean, ll: TranslationFunctions): TranslatedString {
  switch (source) {
    case CalorieIntakeBaseline.Target:
      return forCoach ? ll.nextIntake.sourceTargetCoach() : ll.nextIntake.sourceTargetSelf();
    case CalorieIntakeBaseline.Custom:
      return ll.nextIntake.sourceCustom();
    default:
      // the logged average; a check-up that stored no choice is read the same way, as the overview's
      // baselineSourceText reads it
      return ll.nextIntake.sourceLogged();
  }
}
